import 'css-chunksrc/client/scenes/projectReportSubmission/templateSelector/styles.scss';export default {
  "templateSelector": "_templateSelector_1nb6c_1",
  "input": "_input_1nb6c_5",
  "icon": "_icon_1nb6c_21",
  "listRoot": "_listRoot_1nb6c_29",
  "list": "_list_1nb6c_29",
  "item": "_item_1nb6c_44",
  "selected": "_selected_1nb6c_55",
  "open": "_open_1nb6c_59"
};